<template>
  <div>
    <production-order-data-list :payload="payloadListObj" class="product_table" listName="PRODCUCTION_BY_PRODUCT">
      <template #filterFields>
        <v-autocomplete autocomplete="off" :items="listOfStatus" @change="filterOrders" v-model="filterByWarehouse" item-text="text" item-value="val" clearable :label="$t('message.layout.status')" dense hide-details outlined></v-autocomplete>
      </template>
    </production-order-data-list>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import productionOrderMixin from './productionOrderMixin'
export default {
  mixins: [productionOrderMixin],
  data () {
    return {
      payloadListObj: {
        list: [],
        completeList: [],
        total: 0,
        headers: [],
        addNewRoute: () => this.$router.push(this.routeURL),
        showFiltersSlot: true,
        MODULE_URL: 'productionorders',
        loading: false,
        editProp: 'order_number',
        editURL: (item) => `/production_order/order/actions/${item.order_id}`,
        actionsList: [{
          click: (item) => this.getDataForReport(item.order_id, item.product_id),
          icon: () => 'mdi-download',
          is_show: (item) => true
        }]
      },
      routeURL: '/production_order/order/actions',
      MODULE_URL: 'productionorders',
      filterByWarehouse: ''
    }
  },
  components: {
    'production-order-data-list': () => import('./ProductionOrderDataList')
  },
  computed: {
    ...mapState(['PRODCUCTION_BY_PRODUCT']),
    headers () {
      return [{
        text: this.$t('message.stocks.orderNumber'),
        value: 'order_number'
      }, {
        text: this.$t('message.layout.product'),
        value: 'product_name'
      }, {
        text: this.$t('message.order.startDate'),
        value: 'start_date'
      }, {
        text: this.$t('message.order.endDate'),
        value: 'end_date'
      }, {
        text: this.$t('message.stocks.delivery'),
        value: 'delivery_date'
      }, {
        text: this.$t('message.productionOrder.started'),
        value: 'started_date'
      }, {
        text: this.$t('message.productionOrder.orderedqty'),
        value: 'ordered'
      }, {
        text: this.$t('message.productionOrder.producedqty'),
        value: 'produced'
      }, {
        text: this.$t('message.productionOrder.makingqty'),
        value: 'in_production'
      }, {
        text: this.$t('message.customer.status'),
        value: 'status_text'
      },
      {
        text: this.$t('message.common.actions'),
        sortable: false,
        value: 'actions'
      }]
    }
  },
  watch: {
    search (val) {
      this.filterOrders()
    }
  },
  mounted () {
    this.payloadListObj.headers = this.headers
    const text = this.$t('message.common.deleteSuccess')
    this.$eventBus.$on('deleteItems', (data) => {
      if (data.module === this.MODULE_URL) {
        const payload = { ids: data.ids, url: `${this.MODULE_URL}/delete_multiple`, module: this.MODULE_URL }
        this.$store.commit('showDeleteDialog', payload)
      }
    })
    this.$eventBus.$on('deleteSuccess', (data) => {
      if (data === this.MODULE_URL) {
        this.$root.$emit('snackbar', { snackbar: true, color: 'success', text })
        this.$store.commit('hideDialog')
        this.getListHandler()
      }
    })
    this.$eventBus.$on('hideDownloadReporteLoading', (moduleName) => {
      if (moduleName === this.MODULE_URL) this.payloadListObj.loading = false
    })
    this.getListHandler()
  },
  methods: {
    filterOrders () {
      let list = this.$formatter.cloneVariable(this.payloadListObj.completeList)
      if (this.filterByWarehouse) list = list.filter(x => x.status === this.filterByWarehouse)
      this.payloadListObj.list = list
      this.payloadListObj.total = list.length || 0
    },
    getListHandler () {
      this.payloadListObj.loading = true
      this.payloadListObj.module = this.MODULE_URL
      this.$_getSingleRecordHandler('productionorders/get_orders_by_product')
        .then((response) => {
          const values = response.data
          this.payloadListObj.loading = false
          const transformData = {
            date: { list: ['start_date', 'end_date', 'delivery_date', 'started_date', 'order_date'], from: 'DD.MM.YYYY', to: 'DD.MM.YYYY' },
            number: { list: ['ordered', 'produced', 'in_production'], format: 'replaceDotWithComma' }
          }
          const modelList = this.$_formatListModel(values, transformData)
          modelList.forEach(item => {
            const status = this.listOfStatus.find(x => x.val === item.status)
            if (status) item.status_text = `${status.text}`
            else item.status_text = ''
            item.win_number = item.win_number ? JSON.parse(item.win_number) : []
            const getProductName = item.product_name
            item.product_name = `${getProductName} ${item.win_number && item.win_number.length > 0 ? '<br/> <b>WIN:</b>' : ''} `
            item.win_number.map((x) => {
              item.product_name += `<br/> ${x}`
            })
          })
          this.payloadListObj.completeList = modelList
          this.filterOrders()
        })
    },
    deleteOrder (id) {
      const payload = { url: `${this.MODULE_URL}/${id}`, module: this.MODULE_URL, isSingle: true }
      this.$store.commit('showDeleteDialog', payload)
    },
    getDataForReport (orderId, productId) {
      const model = { order_id: orderId, product_id: productId }
      this.payloadListObj.loading = true
      this.$_executeApi('post', 'productionorders/get_report', model)
        .then((response) => {
          this.$root.$emit('getDataForPDF', { data: response.data, moduleName: this.MODULE_URL })
        })
    }
  },
  beforeDestroy () {
    this.$eventBus.$off('deleteSuccess')
    this.$eventBus.$off('deleteItems')
    this.$eventBus.$off('hideDownloadReporteLoading')
  }
}
</script>
<style>
  .product_table table th, .product_table table td {
    padding: 0 6px !important;
  }
</style>
